/**
 * Phase 18.16-B Batch 1 — /shop-drop-ship (CMS-driven).
 */
import React from "react";
import SEO from "../components/SEO";
import ServicePageCmsWrapper from "../components/ServicePageCmsWrapper";

const SHOP_DROP_SHIP_FALLBACK = {
  page_banner: {
    eyebrow: "Shop, Drop & Ship",
    title: "Shop online,",
    highlight: "wij verzenden",
    subtitle: "Bestel bij Nederlandse webshops, laat alles bij ons afleveren, en wij verzenden uw zending naar de Caribbean.",
    badges: [
      { icon: "package", label: "Online shoppen in NL" },
      { icon: "truck", label: "Wij ontvangen + verzenden" },
      { icon: "user", label: "Mijn 5999Cargo" },
    ],
    cta_primary_label: "Start met Shop, Drop & Ship",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Maak paklijst",
    cta_secondary_url: "/paklijst",
  },
  intro: {
    eyebrow: "Hoe werkt het",
    title: "Online shoppen, wij regelen de rest",
    subtitle: "In een paar stappen krijgt u uw pakketten in de Caribbean. Geen Nederlands adres? Wij ontvangen voor u en verzenden in één keer.",
  },
  cta_band: {
    title: "Klaar om te starten?",
    description: "Maak uw eerste paklijst of vraag een offerte aan — wij staan klaar.",
    cta_primary_label: "Maak paklijst",
    cta_primary_url: "/paklijst",
    cta_secondary_label: "Naar Mijn 5999Cargo",
    cta_secondary_url: "/my5999",
  },
  cards: [],
};

export default function ShopDropShipPage() {
  return (
    <>
      <SEO
        title="Shop, Drop & Ship | 5999Cargo"
        description="Bestel online in Nederland, wij ontvangen en verzenden uw pakketten naar de Caribbean."
      />
      <ServicePageCmsWrapper
        slug="shop-drop-ship"
        fallback={SHOP_DROP_SHIP_FALLBACK}
        testid="shop-drop-ship-page"
      />
    </>
  );
}
